<template>
  <div class="app-call-to-action__container">
    <app-divider v-if="divider" />
    <div class="app-call-to-action__button_container">
      <app-button
        v-bind="leadingButtonConfig"
        :style="spaceCSS"
        class="app-call-to-action__action-button"
        @click="handleClick('leading')"
      />
      <app-button
        v-bind="trailingButtonConfig"
        :style="spaceCSS"
        class="app-call-to-action__action-button"
        @click="handleClick('trailing')"
      />
      <div v-if="comment" class="app-call-to-action__comment-text">
        {{ comment }}
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from './AppButton'
import AppDivider from './AppDivider'

export default {
  name: 'AppCallToAction',
  components: {
    AppButton,
    AppDivider
  },
  props: {
    identifier: {
      type: String,
      default: ''
    },
    leadingTitle: {
      type: String,
      default: 'Secondary'
    },
    leadingURL: {
      type: String,
      default: undefined
    },
    leadingRoute: {
      type: String,
      default: undefined
    },
    leadingColor: {
      type: String,
      default: '#000'
    },
    leadingBackgroundColor: {
      type: String,
      default: '#fff'
    },
    leadingShadow: {
      type: Boolean,
      default: false
    },
    trailingTitle: {
      type: String,
      default: 'Primary'
    },
    trailingUrl: {
      type: String,
      default: undefined
    },
    trailingRoute: {
      type: String,
      default: undefined
    },
    trailingColor: {
      type: String,
      default: '#fff'
    },
    trailingBackgroundColor: {
      type: String,
      default: '#3d3d3d'
    },
    trailingShadow: {
      type: Boolean,
      default: true
    },
    comment: {
      type: String,
      default: undefined
    },
    divider: {
      type: Boolean,
      default: true
    },
    /**
     * @returns An object with a unit, and an array of four values.
     * This object is used to compose interitem spacing.
     */
    interitemSpacing: {
      type: Object,
      default () {
        return {
          unit: 'rem',
          values: [0, 1.15, 0, 1.15]
        }
      }
    }
  },
  computed: {
    leadingButtonConfig () {
      return {
        title: this.leadingTitle,
        url: this.leadingURL,
        route: this.leadingRoute,
        color: this.leadingColor,
        backgroundColor: this.leadingBackgroundColor,
        shadow: this.leadingShadow
      }
    },
    trailingButtonConfig () {
      return {
        title: this.trailingTitle,
        url: this.trailingUrl,
        route: this.trailingRoute,
        color: this.trailingColor,
        backgroundColor: this.trailingBackgroundColor,
        shadow: this.trailingShadow
      }
    },
    spaceCSS () {
      const unit = this.interitemSpacing.unit
      const values = this.interitemSpacing.values
      const marginValue = values
        .map(value => {
          if (value === 0) {
            return '0'
          }
          return `${value}${unit}`
        })
        .join(' ')

      const cssObj = {
        '--app-button-margin': marginValue
      }
      return cssObj
    }
  },
  methods: {
    buttonClick (buttonId) {
      // debugger;
      this.$emit('click', buttonId)
    }
  }
}
</script>

<style scoped>
.app-call-to-action__container {
  display: flex;
  flex-direction: column;
}

.app-call-to-action__button_container {
  display: flex;
  flex-direction: row;
  flex-grow: 100;
  width: 100%;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin-bottom: 1rem;
}

.app-call-to-action__comment-text {
  opacity: 0.3;
  font-family: "Charter-Italic";
  font-size: 1.125rem;
  color: #332924;
  letter-spacing: 0;
  text-align: center;
}

.app-call-to-action__action-button {
  margin: var(--app-button-margin);
}

@media screen and (max-width: 775px) {
  .app-call-to-action__action-button {
    margin: 0.5rem auto !important;
  }
}
</style>
